import React from 'react';
import ShipmentList from '../components/ShipmentList';
// import MinimalNavbar from '../components/MinimalNavbar'; // ⬅️ Importar el navbar

const Dashboard = () => {
  return (
    <div className="min-h-screen bg-gray-900 text-white p-4">
      <ShipmentList />
    </div>
  );
};

export default Dashboard;

